<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo
        :titulo="locale[local].screen.reserva.string001"
      />
      <v-divider />

      <v-container fluid grid-list-md class="pl-1 pr-1">
        <v-layout row wrap align-center justify-center>
          <v-flex xs12 v-for="(cardapio, cardapioKey) in cardapios" :key="cardapioKey">
            <v-card style="border-radius: 10px" class="pa-2 elevation-5">
              <v-card-text class="text-left">
                <v-layout
                  row
                  wrap
                  justify-space-between
                  align-center
                  class="hidden-sm-and-down"
                >
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{ cardapio.descricaoPortal }}</h2>
                      </v-flex>
                      <v-flex xs12>
                        <h4>Horário Limite para Reserva: {{ cardapio.hrLimReserva }}</h4>
                      </v-flex>
                      <v-flex xs6 lg3>
                        <h4>Observação: {{ cardapio.observacao }}</h4>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <div style="text-align: center">
                    <v-btn color="primary" @click="showDialog(cardapio)" :disabled="cardapio.jaReservou">
                      <v-icon left>mdi-check-bold</v-icon>Reservar Restaurante
                    </v-btn>
                  </div>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card-text>
              <v-overlay v-model="carregando">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
            </v-card-text>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
import moment from "moment";
import { alert } from "cids-cgi/lib/util";

export default {
  data: () => ({
    snackbar: false,
    cardapios: [],
    carregando: false,
    dialog: false,
    showProgress: false,
  }),
  async mounted() {},
  created() {
    moment.locale("pt-br");
    this.buscarCardapio();
  },
  methods: {
    async buscarCardapio() {
      this.carregando = true;

      try {
        const service = new Service();
        this.cardapios = await service.buscaCardapio();

      } catch (e) {
      } finally {
        this.carregando = false;
      }
    },
    async showDialog(cardapio) {
      const confirm = await alert.confirm({
          message: 'Deseja fazer a substituição da proteína?',
          color: "orange"
        })

      this.carregando = true;
      
      try {
        const service = new Service();
        const payload = cardapio
        payload.substProteina = confirm

        const retorno = await service.gravaReserva(payload);
  
        if (retorno[0].estatus === "Erro"){
          alert.show({ message: retorno[0].msgErro.split("2 - ")[1], color: 'red'  });
        } else  {
          alert.show({ message: retorno[0].msgErro.split("1 - ")[1], color: 'green'  });
          cardapio.jaReservou = true
        }

      } catch (e) {
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>
